import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

//Local
import { __ } from '../../lib/i18n';
import { Footer, LoadingModal } from '../../components';
import { fetchPlans } from '../../redux/actions/billingActions';
import {
  selectFetchingError,
  selectIsFetchingPlans,
} from '../../redux/selectors/billingSelector';
import PricingHeader from './PricingHeader';
import PricingGrid from './pricingContainer';
import CustomAlert from '../../components/CustomAlert';
import TitleComponent from '../../components/TitleComponent';
import './styles.css';
import { createPaymentIntent } from '../../redux/slices/plan';
import CustomAlertAndButton from '../../components/CustomAlertAndButton';

const plans = [
  {
    name: 'P_1_NAME',
    priceMonth: 20,
    priceYear: 200,
    description: 'P_1_DESC',
    featured: false,
    freeTrial: true,
    features: [
      {
        name: 'PF_1_1',
        enabled: false,
      },
      {
        name: 'PF_1_2',
        enabled: false,
      },
      {
        name: 'PF_1_3',
        enabled: false,
      },
      {
        name: 'PF_1_4',
        enabled: true,
        onclick: 'https://itunes.apple.com/app/yuge/id1046505084',
        style: 'border-bottom border-dark a-blue-500 cursor-pointer',
      },
      {
        name: 'PF_1_5',
        enabled: true,
      },
      {
        name: 'PF_1_6',
        enabled: true,
      },
      {
        name: 'PF_1_7',
        enabled: true,
      },
    ],
  },
  {
    name: 'P_2_NAME',
    priceMonth: 150,
    priceYear: 1500,
    description: 'P_2_DESC',
    featured: true,
    freeTrial: true,
    features: [
      {
        name: 'PF_1_1',
        enabled: true,
      },
      {
        name: 'PF_2_3',
        enabled: true,
      },
      {
        name: 'PF_1_3',
        enabled: true,
      },
      {
        name: 'PF_1_4',
        enabled: true,
      },
      {
        name: 'PF_2_1',
        enabled: true,
      },
      {
        name: 'PF_1_6',
        enabled: true,
        onclick:
          'https://apps.apple.com/nl/app/yuge-merchant/id6443528979?l=en',
        style: 'border-bottom border-dark a-blue-500 cursor-pointer',
      },
      {
        name: 'PF_2_2',
        enabled: true,
      },
    ],
    // features: ['PF_2_1', 'PF_2_2', 'PF_2_3', 'PF_2_4', 'PF_2_5', 'PF_2_6'],
  },
  {
    name: 'P_3_NAME',
    priceMonth: 0,
    priceYear: 0,
    description: 'P_3_DESC',
    featured: false,
    freeTrial: false,
    features: [
      {
        name: 'PF_3_1',
        enabled: true,
      },
      {
        name: 'PF_3_2',
        enabled: true,
      },
      {
        name: 'PF_3_3',
        enabled: true,
      },
    ],
    // features: ['PF_3_1', 'PF_3_2', 'PF_3_3'],
  },
];

const Billing = () => {
  const dispatch = useDispatch();
  const {
    app: {
      user: { planId },
      lang,
    },
    plan: { isCreatingPaymentIntent, errorCreatingPaymentIntent },
  } = useSelector((state) => state);

  const [message, setMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const fetchingPlans = useSelector(selectIsFetchingPlans);
  const fetchingError = useSelector(selectFetchingError);

  useEffect(() => {
    dispatch(fetchPlans());
  }, [dispatch]);

  useEffect(() => {
    if (errorCreatingPaymentIntent) {
      setErrorMessage(__(lang, 'ERROR_900'));
    }
  }, [errorCreatingPaymentIntent]);

  useEffect(() => {
    if (isCreatingPaymentIntent) {
      setErrorMessage(null);
    }
  }, [isCreatingPaymentIntent]);

  const [period, setPeriod] = useState('year');
  const [firstRender, setFirstRender] = useState(true);
  function handleFirstRender() {
    setFirstRender(false);
  }
  function handleSelectPlan(index) {
    setFirstRender(true);
    if (!index && index !== 0) return;
    const id = period == 'month' ? plans[index].idMonth : plans[index].idYear;
    dispatch(createPaymentIntent(id)).then((result) => {
      const { url } = result.payload;
      window.location.href = url;
    });
  }
  function handlePeriod() {
    handleFirstRender();
    switch (period) {
      case 'month':
        handleSelectPlan();
        setPeriod('year');
        break;
      default:
        setPeriod('month');
        break;
    }
  }

  return (
    <main
      role="main"
      className={
        'container-fluid  pt-3 px-4'
      }>
      {message && (
        <CustomAlert type={'info'} onDismiss={() => setMessage(null)}>
          {message}
        </CustomAlert>
      )}
      {errorMessage && (
        <CustomAlert type={'error'} onDismiss={() => setMessage(null)}>
          {errorMessage}
        </CustomAlert>
      )}
      <LoadingModal isLoading={fetchingPlans || isCreatingPaymentIntent} />
      <TitleComponent title={__(lang, 'BILLING')} />
      {planId === null && (
        <CustomAlert type={'warning'} noDimiss={true}>
          {__(lang, 'FREE_PLAN_WARNING')}. {__(lang, 'SELECT_PLAN_WARNING')}.
        </CustomAlert>
      )}
      {plans.length > 0 && (
        <div className="page-pricing2">
          <div className="page-pricing px-4 md:px-16 mt-4 pt-4">
            <div className="flex flex-col items-center justify-between">
              <PricingHeader
                lang={lang}
                period={period}
                handlePeriod={handlePeriod}
              />
              <PricingGrid
                plans={plans}
                lang={lang}
                billingPeriod={period}
                firstRender={firstRender}
                handleSelectPlan={handleSelectPlan}
              />
            </div>
          </div>
        </div>
      )}
      {fetchingError && (
        <div className="row h-75 align-items-center justify-content-center">
          <div
            className="alert alert-danger"
            style={{ height: 'fit-content' }}
            role="alert">
            {__(lang, 'ERROR_FETCHING_PLANS')}
          </div>
        </div>
      )}
      <Footer />
    </main>
  );
};

export default Billing;
